export const DEFAULT_TAGS = {
  system: {
    name: 'System',
    color: 'var(--sl-color-neutral-0)',
    icon: 'settings'
  },
  data_collection: {
    name: 'Data Collection',
    color: 'var(--sl-color-sky-50)',
    icon: 'photo_camera'
  },
  make_ready: {
    name: 'Make Ready',
    color: 'var(--sl-color-green-50)',
    icon: 'format_line_spacing'
  },
  pla: {
    name: 'PLA',
    color: 'var(--sl-color-orange-50)',
    icon: '3d_rotation',
    tooltip: 'Pole Loading Analysis'
  },
  pci: {
    name: 'PCI',
    color: 'var(--sl-color-fuchsia-50)',
    icon: 'assignment',
    tooltip: 'Post Construction Inspection'
  }
};

export const DEFAULT_CATEGORY_TAG_MAP = {
  clearance_rules: ['make_ready'],
  proposed_cable_logic: ['make_ready'],
  default_specs: ['pla'],
  pole_specs: ['pla'],
  wire_specs: ['pla'],
  anchor_specs: ['pla'],
  insulator_specs: ['pla'],
  arm_specs: ['pla'],
  equipment_specs: ['pla'],
  sidewalk_brace_specs: ['pla'],
  pushbrace_specs: ['pla'],
  load_cases: ['pla']
};

export const DEFAULT_ITEM_TAG_MAP = {
  attributes: {
    PCI_1_date: ['pci'],
    PCI_failure_type: ['pci'],
    PCI_field_note: ['pci'],
    PCI_inspection_count: ['pci'],
    PCI_note: ['pci'],
    PCI_passed_NESC_safety_check: ['pci'],
    PCI_pole_count: ['pci'],
    PCI_proper_guying_was_installed: ['pci'],
    PCI_surveys: ['pci'],
    address: ['data_collection'],
    anc_elevation: ['data_collection'],
    anchor_eyes: ['data_collection'],
    anchor_id: ['pla'],
    anchor_spec: ['pla', 'construction_specs'],
    anchor_was_installed: ['pci'],
    arm_spec: ['pla', 'construction_specs'],
    attaches_to_back: ['data_collection'],
    bearing: ['pla'],
    birthmark: ['data_collection'],
    cabinet_spec: ['pla'],
    cable_type: ['data_collection'],
    cable_was_bonded: ['pci'],
    calculated_groundline_circumference: ['data_collection'],
    capacitor_spec: ['pla'],
    company: ['system'],
    coms_as_designed: ['pci'],
    connection_type: ['data_collection'],
    cost_causer: ['make_ready'],
    county: ['data_collection'],
    'cross-sectional_depth': ['pla'],
    'cross-sectional_height': ['pla'],
    'cross-sectional_width': ['pla'],
    custom_equipment: ['pla'],
    custom_tension: ['pla'],
    cut_pole: ['pla'],
    cutout_arrestor_spec: ['pla'],
    diameter: ['data_collection'],
    done: ['data_collection'],
    down_guy_installed: ['pci'],
    drip_loop_spec: ['pla'],
    effective_groundline_circumference: ['data_collection'],
    equipment_type: ['data_collection'],
    equipment_weight: ['pla'],
    existing_aux_eye: ['data_collection'],
    field_completed: ['data_collection'],
    flag_for_review: ['data_collection'],
    foreign_utility_make_ready: ['make_ready'],
    google_elevation: ['system'],
    grounded: ['data_collection'],
    grounding: ['data_collection'],
    guying_type: ['data_collection'],
    height: ['data_collection'],
    horizontal_offset: ['pla'],
    insulated: ['make_ready'],
    insulator_spec: ['pla'],
    job_name: ['system'],
    label: ['system', 'data_collection'],
    lasered_cable_height: ['data_collection'],
    lasered_ground_height: ['data_collection'],
    load_case: ['pla'],
    loading_notes: ['pla'],
    loading_percentage: ['pla'],
    loading_result: ['pla'],
    manual_height: ['system', 'data_collection'],
    measured_elevation: ['data_collection'],
    measured_groundline_circumference: ['data_collection'],
    measured_pole_height: ['data_collection'],
    measurement_of: ['data_collection'],
    mr_category: ['make_ready'],
    mr_existing_bolt_hole: ['make_ready'],
    mr_ignore: ['make_ready'],
    mr_move: ['make_ready'],
    mr_note: ['make_ready'],
    mr_remove: ['make_ready'],
    mr_resolved: ['make_ready'],
    mr_state: ['make_ready'],
    municipality: ['data_collection'],
    new_attacher_constructed: ['pci'],
    new_attachment_as_designed: ['pci'],
    node_sub_type: ['data_collection'],
    node_type: ['system', 'data_collection'],
    note: ['system', 'data_collection'],
    over: ['make_ready'],
    owner: ['system', 'data_collection'],
    pickup_description: ['data_collection'],
    pickup_required: ['data_collection'],
    pla_ignore: ['pla'],
    point_load_end: ['pla'],
    pole_class: ['pla'],
    pole_count: ['system'],
    pole_height: ['system', 'pla'],
    pole_spec: ['system', 'data_collection', 'pla'],
    pole_species: ['system', 'data_collection', 'pla'],
    pole_tag: ['system', 'data_collection'],
    pole_top_extension: ['make_ready', 'pla'],
    poles_built_correctly_in_app: ['pci'],
    post_construction: ['pci'],
    post_construction_inspection: ['pci'],
    post_construction_proposed: ['pci'],
    post_construction_status: ['pci'],
    power_as_designed: ['pci'],
    power_mr_annotation: ['make_ready'],
    proposed: ['make_ready', 'pla'],
    proposed_anchor_id: ['make_ready', 'pla'],
    proposed_ground: ['make_ready', 'pla'],
    proposed_ground_rod: ['make_ready', 'pla'],
    proposed_pole_spec: ['make_ready', 'pla'],
    proposed_rod_size: ['make_ready', 'pla'],
    proposed_wire_spec: ['make_ready', 'pla'],
    pushbrace_spec: ['pla'],
    recloser_spec: ['pla'],
    reference_type: ['pla'],
    regulator_spec: ['pla'],
    riser_spec: ['pla'],
    riser_type: ['pla'],
    rod_size: ['data_collection', 'pla'],
    scid: ['system', 'data_collection'],
    shape_factor: ['pla'],
    sidewalk_brace_id: ['pla'],
    sidewalk_brace_spec: ['pla'],
    sizes_of_attached_dn_guys: ['data_collection'],
    soil_type: ['pla'],
    state: ['data_collection'],
    street_address: ['data_collection'],
    street_light_bracket_spec: ['pla'],
    street_light_spec: ['pla'],
    street_name: ['data_collection'],
    street_number: ['data_collection'],
    switch_spec: ['pla'],
    time_bucket: ['system', 'data_collection'],
    township: ['data_collection'],
    tracing_complete: ['data_collection'],
    transformer_bank_spec: ['pla'],
    transformer_spec: ['pla'],
    vantage_point: ['system', 'data_collection'],
    verify_location_in_field: ['data_collection'],
    warning: ['system', 'data_collection'],
    wire_spec: ['pla'],
    wire_tension: ['pla'],
    zip_code: ['data_collection']
  },
  tools: {
    PCI_routine: ['pci'],
    address_data: ['data_collection'],
    aerial: ['data_collection'],
    anchor: ['data_collection'],
    associate_photos: ['system'],
    building_ref: ['data_collection'],
    bulk_pole_load: ['pla'],
    calc_bearings: ['pla'],
    calc_ground_line: ['pla'],
    clear_warnings: ['system', 'data_collection'],
    com_reference: ['data_collection'],
    copy_nodes: ['system'],
    fix_map_errors: ['system'],
    google_elevation: ['system'],
    handhole: ['data_collection'],
    insert_anchor_spec: ['pla'],
    insert_com_spec: ['pla'],
    insert_pole: ['system'],
    insert_pole_spec: ['pla'],
    insert_sections: ['data_collection'],
    join_all_nodes: ['data_collection'],
    join_osp: ['make_ready'],
    join_osp_aerial: ['make_ready'],
    join_osp_overlash: ['make_ready'],
    link_map_photo_data: ['pla'],
    manhole: ['data_collection'],
    map_note: ['data_collection'],
    measure_bearing: ['pla'],
    measure_heights: ['data_collection'],
    mr_violations: ['make_ready'],
    multi_add_attribute: ['system'],
    multi_delete_item: ['system'],
    other_osp_connection: ['data_collection'],
    power_reference: ['data_collection'],
    power_xover: ['data_collection'],
    prep_for_post_construction: ['pci'],
    pwr_bld_ref: ['data_collection'],
    scrape_photo_data: ['data_collection'],
    section: ['data_collection'],
    set_order: ['data_collection'],
    set_power_wire_spec: ['pla'],
    set_vantage_point: ['data_collection'],
    show_un_associated_photos: ['data_collection'],
    slack_loop: ['pla'],
    splice: ['make_ready'],
    un_associate_photos: ['data_collection'],
    underground_obstacles: ['data_collection'],
    underground_path: ['data_collection']
  },
  photo_elements: {
    anchor_calibration: ['system'],
    arm: ['data_collection'],
    back: ['system'],
    birthmark: ['data_collection'],
    cableTag: ['data_collection'],
    equipment: ['data_collection'],
    ground_marker: ['data_collection'],
    grounding: ['data_collection'],
    groundline_circumference: ['data_collection'],
    guying: ['data_collection'],
    hallway: ['system'],
    inspection_tag: ['data_collection'],
    insulator: ['data_collection'],
    job: ['system'],
    midspanHeight: ['system'],
    miscellaneous: ['system'],
    note: ['system'],
    poleHeight: ['system'],
    pole_tag: ['system'],
    pole_top: ['system'],
    rubbish: ['system'],
    side: ['system'],
    sync: ['system'],
    tag: ['system'],
    upshot: ['system'],
    wire: ['system']
  },
  photo_routines: {
    Anchor_Point: ['data_collection'],
    Arm: ['data_collection'],
    Birthmark: ['data_collection'],
    Cable_Tag: ['data_collection'],
    Down_Guy: ['data_collection'],
    Equipment: ['data_collection'],
    Grounding: ['data_collection'],
    Groundline_Circumference: ['data_collection'],
    Guying: ['data_collection'],
    Hallway: ['system'],
    Inspection_Tag: ['data_collection'],
    Insulator: ['data_collection'],
    Midspan_Height: ['system'],
    Miscellaneous: ['system'],
    No_Birthmark: ['system'],
    No_Tag: ['data_collection'],
    Note: ['system'],
    Pole_Height: ['system'],
    Pole_Tag: ['data_collection'],
    Pole_Top_Extension: ['data_collection'],
    Riser: ['data_collection'],
    Rubbish: ['system'],
    Secondary_Drip_Loop: ['data_collection'],
    Side: ['system'],
    Street_Light: ['data_collection'],
    Sync_and_Job: ['system'],
    Transformer: ['data_collection'],
    Upshot: ['system'],
    Wire: ['system']
  }
};
